let _ = t => t,
  _t,
  _t2;
import styled, { css } from 'styled-components';
import { colors, fonts, fontSize } from '@ovpn-ui/styles';
export const inputBaseStyles = css(_t || (_t = _`
    box-sizing: border-box;
    width: 100%;
    height: 24px;
    margin: 0;
    padding: 8px 16px;

    color: ${0};

    font-size: ${0};
    font-family: ${0};
    line-height: ${0};

    border: none;
    outline: none;

    &:disabled {
        color: ${0};
    }
`), colors.neutralTextTitle, fontSize.default, fonts.basic, fontSize.xxMedium, colors.neutralTextPlaceholder);
const StyledInput = styled.input(_t2 || (_t2 = _`
    ${0};

    &::placeholder {
        color: ${0};
    }

    &:focus::placeholder,
    &:active::placeholder {
        color: ${0};
    }

    &:disabled::placeholder {
        color: ${0};
    }

    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        margin: 0;
    }

    &[type='password'] {
        color: ${0};
    }
`), inputBaseStyles, colors.neutralTextPlaceholder, colors.neutralTextPlaceholder, colors.neutralTextPlaceholder, colors.neutralTextBody);
export default StyledInput;